import { render } from "./PermeabilityFilter.vue?vue&type=template&id=fcd0164a"
import script from "./PermeabilityFilter.vue?vue&type=script&lang=js"
export * from "./PermeabilityFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__